import { useDarkMode } from '../../context/DarkModeContext';

const PRESETS_LIGHT = {
  success: { bg: '#dcfce7', color: '#166534' },
  danger: { bg: '#fef2f2', color: '#991b1b' },
  warning: { bg: '#fef3c7', color: '#92400e' },
  info: { bg: '#e8f0fe', color: '#1e40af' },
  neutral: { bg: '#F5F7FA', color: '#4B5563' },
};

const PRESETS_DARK = {
  success: { bg: '#064e3b', color: '#6ee7b7' },
  danger: { bg: '#7f1d1d', color: '#fca5a5' },
  warning: { bg: '#78350f', color: '#fcd34d' },
  info: { bg: '#1e3a5f', color: '#93c5fd' },
  neutral: { bg: '#1e293b', color: '#94a3b8' },
};

export default function Badge({ label, variant = 'neutral', dot, style }) {
  const { darkMode } = useDarkMode();
  const PRESETS = darkMode ? PRESETS_DARK : PRESETS_LIGHT;
  const preset = PRESETS[variant] || PRESETS.neutral;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '2px 8px',
        borderRadius: '8px',
        fontSize: '10px',
        fontWeight: 700,
        fontFamily: 'inherit',
        letterSpacing: '0.02em',
        background: preset.bg,
        color: preset.color,
        whiteSpace: 'nowrap',
        userSelect: 'none',
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            background: preset.color,
            flexShrink: 0,
          }}
        />
      )}
      {label}
    </span>
  );
}
